import { DigitRoll } from '../digit-roll';

const TILE = 'h-[101px] w-[74px]';
/** As Figma draws it, even at zero; `donation-count` caps `TOTAL` alike, so no fourth tile shifts the copy mid-visit. */
const MIN_TILES = 3;

/** `DigitRoll` is pure CSS, reduced motion included, so no flag is threaded down to it. */
function DigitTile(props: { value: number }) {
	return (
		<DigitRoll
			digit={props.value}
			className={`bg-brand rounded-lg ${TILE}`}
			cell={`flex items-center justify-center text-[4.5rem] leading-none font-medium tracking-[-0.02em] text-black tabular-nums ${TILE}`}
		/>
	);
}

/** Screen readers get the plain number; the tiles are only its animation. */
export function DonationOdometer(props: { count: number }) {
	const digits = String(props.count).padStart(MIN_TILES, '0').split('').map(Number);

	return (
		<div className="flex shrink-0 gap-2" role="status" aria-live="polite" aria-atomic>
			<span className="sr-only">{props.count}</span>
			{digits.map((d, i) => (
				// oxlint-disable-next-line react/no-array-index-key
				<DigitTile key={i} value={d} />
			))}
		</div>
	);
}
